import React from "react";
import ReactDOM from "react-dom";
import { AppContainer } from "react-hot-loader";
import App from "./App";

// Export your top level component (for static rendering)
export default App;

function renderApp() {
  // Render your app
  if (typeof document !== "undefined") {
    const renderMethod = module.hot ? ReactDOM.render : ReactDOM.hydrate;
    const render = (Comp: React.ComponentType) => {
      renderMethod(
        <AppContainer>
          <Comp />
        </AppContainer>,
        document.getElementById("root")
      );
    };

    // Render!
    render(App);

    // Hot Module Replacement
    if (module.hot) {
      module.hot.accept("./App", () => {
        render(require("./App").default);
      });
    }
  }
}

if (!global.Intl) {
  require.ensure(
    [
      "intl",
      "intl/locale-data/jsonp/en.js",
      "intl/locale-data/jsonp/fi.js",
      "intl/locale-data/jsonp/ru.js",
    ],
    (require) => {
      require("intl");
      require("intl/locale-data/jsonp/en.js");
      require("intl/locale-data/jsonp/fi.js");
      require("intl/locale-data/jsonp/ru.js");
      renderApp();
    }
  );
} else {
  renderApp();
}



// WEBPACK FOOTER //
// /Users/ek1z/dev/flowfestival-com/src/index.tsx